import React from 'react'
import bi from '../../images/unknown.jpg'
import { BottomContainer, OutSider } from './BottomElements'

const Bottom = () => {
    return (
        <OutSider>
        <BottomContainer>
            <img src={bi} className="bottomImg" />
        </BottomContainer>
        </OutSider>
    )
}

export default Bottom
